import { API_ROOT } from '../../config/config'
import { doGet, doPut } from './utils'

// const API_ROOT = 'http://localhost:9011/api'

export const getApprovalPdpa = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/pdpa`
  return doGet(url)
}

export const updateApprovalPdpa = (projectVersionId, request) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/pdpa`
  return doPut(url, request)
}
